// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import { Box, Paper, Stack, Table, Text, Title } from '@mantine/core';
import type { JSX } from 'react';

/**
 * TODO(patient-chart-notes): Clinical notes are not yet modeled in FHIR in
 * this codebase. When they are — likely as `DocumentReference` with a
 * `clinical-note` category tied to an `Encounter` — wire them up here.
 *
 * Columns per the mock: Date, Appointment Type, Provider, Note, Follow-up,
 * Actions (View Note).
 */
export function DoctorsNotesSection(): JSX.Element {
  return (
    <Paper withBorder radius="md" shadow="sm" p="xl">
      <Title order={2} mb="md">
        Doctor's Notes
      </Title>
      <Box style={{ overflowX: 'auto' }}>
        <Table highlightOnHover withTableBorder>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Date</Table.Th>
              <Table.Th>Appointment Type</Table.Th>
              <Table.Th>Provider</Table.Th>
              <Table.Th>Note</Table.Th>
              <Table.Th>Follow-up</Table.Th>
              <Table.Th>Actions</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            <Table.Tr>
              <Table.Td colSpan={6}>
                <Stack align="center" py="md" gap={4}>
                  <Text c="dimmed">No clinical notes yet.</Text>
                  <Text size="xs" c="dimmed">
                    Notes from your visits will appear here after your provider records them.
                  </Text>
                </Stack>
              </Table.Td>
            </Table.Tr>
          </Table.Tbody>
        </Table>
      </Box>
    </Paper>
  );
}
